export const MY_DELIVERY_OPTION_FORM = 'app/MyDelivery/MY_DELIVERY_OPTION_FORM';
export const SAVE_INFO_MES_OPTIONS = 'app/MyDelivery/SAVE_INFO_MES_OPTIONS';
export const REQUEST_SUBSCRIPTION_TYPES_SUCCESS =
  'app/MyDelivery/REQUEST_SUBSCRIPTION_TYPES_SUCCESS';
export const CLASSIC = 'CLASSIC';
export const DEFAULTVALUE = '1';
export const MY_DELIVERY_REDUCER = 'MyDelivery';
export const REQUEST_INDEX_INTEGRITY_SUCCESS = 'app/MyDelivery/REQUEST_INDEX_INTEGRITY_SUCCESS';
